export const SINAN_TYPE_DATE_FILTERS = [
    { label: "1º Sintoma", value: "DT_SIN_PRI" },
    { label: "Notificação", value: "DT_NOTIFIC" }, 
    { label: "Digitação", value: "DT_DIGITA" }    
]